import { CartItem } from '../cart/cart-item'

/**
 * 送料無料フラグの商品を含む注文は、ブランドの送料設定によらず送料が無料になる（正は server の `SelectShippingFee::selectFixedFee`）。
 */
export function containsFreeShippingItem(items: ReadonlyArray<CartItem>): boolean {
  return items.some(item => item.freeShipping)
}
